import { Link } from 'react-router-dom';
import { handleShare } from '../Utilis/helpers'
import React from 'react'
import { useReadArticles } from '../hooks/useReadArticles';
interface newsItem {
  id: string,
  post_featured_image: string;
  post_title: string;
  isVideo?: boolean;
  isBreaking?: boolean;
  isPoll?: boolean;
  description: string;
  created: string;
  user: string;
  isLive:any;
  post_slug:string,
  type:string,
}
interface newsGridProps {
  news: newsItem,
  darkMode:boolean,
  fontSize: string
}

export const Newsgrid: React.FC<newsGridProps> = ({news, darkMode, fontSize}) => {
  const { checkIfArticleRead } = useReadArticles();
        const isArticleReadDone = checkIfArticleRead(news?.id, news?.type)
  return (
      <div 
                  key={news.id} 
                  className={`mb-4 rounded-lg overflow-hidden shadow-lg ${darkMode ? 'bg-gray-800' : 'bg-white'}`}
                >
                  <div className="relative"> 
                    {!isArticleReadDone && (<Link id={news?.post_slug}
                  to={`/news/${news?.post_slug}`} className="">              
                    <img 
                      src={news?.post_featured_image} 
                      alt={news?.post_title}                      
                      className={`w-full h-48 object-cover object-top`}
                    />
                    </Link>)}
                       
                    {news?.isVideo && (
                      <div className="absolute inset-0 flex items-center justify-center">
                        <div className="bg-black bg-opacity-50 rounded-full p-3">
                          <i className="fas fa-play text-white text-xl"></i>
                        </div>
                      </div>
                    )}
                    {news?.isBreaking && (
                      <div className="absolute top-0 left-0 bg-red-600 text-white px-3 py-1 text-sm font-bold">
                        BREAKING
                      </div>
                    )}
                    {news?.isPoll && (
                      <div className="absolute bottom-0 left-0 right-0 bg-black bg-opacity-70 text-white p-2">
                        <div className="flex justify-between items-center">
                          <span className="text-sm">Match-42</span>
                          <button className="bg-white text-black px-2 py-1 rounded text-xs font-bold !rounded-button">
                            VOTE <i className="fas fa-check-circle"></i>
                          </button>
                        </div>
                      </div>
                    )}
                  </div>
                  <div className="p-3">
                    
                       <Link id={news?.post_slug}
                  to={`/news/${news?.post_slug}`} className="">
                    <h2 className={`font-bold mb-2 ${fontSize === 'small' ? 'text-lg' : fontSize === 'large' ? 'text-2xl' : 'text-xl'} ${isArticleReadDone && 'text-gray-700'}`}>
                      {news?.post_title}
                    </h2>
                    </Link>
                    <p className={`${darkMode ? 'text-gray-300' : 'text-gray-600'} mb-3 ${fontSize === 'small' ? 'text-xs' : fontSize === 'large' ? 'text-base' : 'text-sm'}`}>
                      {news?.description}
                    </p>
                    <div className="flex justify-between items-center">
                      <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                        <i className="far fa-clock mr-1"></i> {news?.created}
                      </span>
                      <div className="flex space-x-2">
                        <button 
                          onClick={() => handleShare(news)}
                          className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} cursor-pointer !rounded-button`}
                        >
                          <i className="fas fa-share-alt"></i>
                        </button>
                        <span className={`text-xs px-2 py-1 rounded capitalize ${darkMode ? 'bg-gray-700 text-gray-300' : 'bg-gray-200 text-gray-700'}`}>
                          {news?.user}
                        </span>
                      </div>
                    </div>
                  </div>
                </div>
  )
}

export const Newsgrid2: React.FC<newsGridProps> = ({news, darkMode, fontSize}) => {
  const { checkIfArticleRead } = useReadArticles();
        const isArticleReadDone = checkIfArticleRead(news?.id, news?.type)        
  return (
     <div key={news?.id}
                       className={`mb-3 rounded-lg overflow-hidden shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'} flex`}>
                       <div className="w-2/5">
                         <div className="relative h-full">
                          <Link id={news?.post_slug} to={`/news/${news?.post_slug}`}>
                           <img 
                             src={news?.post_featured_image} 
                             alt={news?.post_title} 
                             className={`w-full h-full object-cover object-top ${isArticleReadDone && 'opacity-20'}`}
                           /> </Link>
                           {news?.isLive && (
                             <div className="absolute top-0 left-0 bg-red-600 text-white px-2 py-0.5 text-xs font-bold rounded-br">
                               LIVE
                             </div>
                           )}
                         </div>
                       </div>
                       <div className="w-3/5 p-2">
                       <Link id={news?.post_slug} to={`/news/${news?.post_slug}`}>
                         <h3 className={`font-medium ${fontSize === 'small' ? 'text-sm' : fontSize === 'large' ? 'text-lg' : 'text-base'} line-clamp-2 ${isArticleReadDone && 'text-gray-400'}` }>
                           {news?.post_title}
                         </h3></Link>
                         <div className="flex justify-between items-center mt-2">
                           <span className={`text-xs ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                             {news?.created}
                           </span>
                           <button 
                             onClick={() => handleShare(news)}
                             className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'} cursor-pointer !rounded-button`}>
                             <i className="fas fa-share-alt"></i>
                           </button>
                         </div>
                       </div>
                     </div>
  )
}



export const Newsgrid3: React.FC<newsGridProps> = ({news, darkMode, fontSize}) => {
    const { checkIfArticleRead } = useReadArticles();
        const isArticleReadDone = checkIfArticleRead(news?.id, news?.type)        
  return (    
     <div className="grid grid-cols-1 gap-3 mb-3">                   
                       <div className={`rounded-lg overflow-hidden shadow-md ${darkMode ? 'bg-gray-800' : 'bg-white'}`}
                       >
                         <div className="aspect-squarex overflow-hidden">
                          <Link id={news?.post_slug} to={`/news/${news?.post_slug}`}>
                           <img 
                             src={news?.post_featured_image} 
                             alt={news?.post_title}  
                             className={`w-full h-fullx object-cover object-top ${isArticleReadDone && 'opacity-20'}`}
                           /> </Link>                          
                         </div>
                         <div className="p-2">
                          <Link id={news?.post_slug} to={`/news/${news?.post_slug}`}>
                           <h3 className={`font-medium ${fontSize === 'small' ? 'text-xs' : fontSize === 'large' ? 'text-base' : 'text-sm'} line-clamp-2 ${isArticleReadDone && 'text-gray-400'}`}>
                             {news?.post_title}
                             <span className={`text-xs ml-2 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>
                               {news?.created}
                             </span> 
                           </h3> </Link>
                           <div className="flex justify-between items-center mt-1">
                             
                             <button 
                               onClick={() => handleShare(news)}
                               className={`text-xs ${darkMode ? 'text-gray-300' : 'text-gray-600'} cursor-pointer !rounded-button`}
                             >
                               <i className="fas fa-share-alt"></i>
                             </button>
                           </div>
                         </div>
                       </div>                 
                     </div>
  )
}

